import { call, put } from 'redux-saga/effects';
import { handleServerError } from 'store/alerts/actions';
import { TAGS_PER_PAGE } from 'consts/queries';
import { ensureHttpsForTags } from 'functions/ensureHttpsUrl';
import * as shopActions from '../actions';
import * as shopApi from '../api';

function* fetchTags({ payload: { retailers, brands, sort_by, search, min_price, page } }) {
  try {
    yield put(shopActions.setTags({ loading: true }));
    const { data } = yield call(shopApi.fetchTags, {
      retailers,
      brands,
      sort_by,
      search,
      min_price,
      page,
    });
    const { tags_left, tags } = data;

    yield put(
      shopActions.receiveTags({
        tagsLeft: !!(tags_left && tags.length === TAGS_PER_PAGE),
        tags: ensureHttpsForTags(tags),
        page: page || 1,
      }),
    );
  } catch (error) {
    yield put(handleServerError(error));
  } finally {
    yield put(shopActions.setTags({ loading: false }));
  }
}

export default fetchTags;
